import CONSTANTS from "./constants";

const { CAREER_OPTIONS } = CONSTANTS.OPTIONS;

export default value => {
    let text = "";
    const career = CAREER_OPTIONS.find((i) => i.value === value);
    text = career ? career.text : "N/A";
    return text;
}